import React from 'react';
export const NativeOption = (props) => React.createElement("option", { ...props });
//# sourceMappingURL=native-option.js.map